module.exports = __webpack_public_path__ + "media/images/emoticons/typhoon-2a4549b96936bf5a1fa21abb96b47dca.gif";